// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__10V6G","colBig":"styles_colBig__14UCa","colSmall":"styles_colSmall__36EnO"};